module.exports = __webpack_public_path__ + "img/new_platform.5ab299bd.png";